import { SET_CUSTOM_FILTER_SEARCH_MYFLEET } from './types';

const setCustomFIlter = (customFilterValues: any) => ({
  type: SET_CUSTOM_FILTER_SEARCH_MYFLEET,
  customFilterValues,
});

export { setCustomFIlter };
